import { Coins } from "lucide-react";
import { CURRENCIES } from "@/lib/currency";

/* CurrencySwitcher — compact pill with a native <select> underneath.
   Shared between the Pricing Calculator and the Earnings Calculator so a change
   in one updates the other (both read the same state from the parent).
   Uses a native <select> instead of a Radix dropdown to avoid body-scroll-lock
   that was breaking the sticky header on iOS PWA. */
export const CurrencySwitcher = ({
  lang = "ar",
  theme = "dark",
  currency = "SAR",
  setCurrency,
  testIdPrefix = "currency",
  size = "md",
}) => {
  const dark = theme === "dark";
  const C = CURRENCIES[currency] || CURRENCIES.SAR;
  const h = size === "sm" ? "h-8" : "h-10";

  return (
    <label
      data-testid={`${testIdPrefix}-wrapper`}
      className={`relative inline-flex items-center gap-1.5 ${h} px-3 rounded-full border font-bold text-xs cursor-pointer transition-colors whitespace-nowrap shrink-0 ${
        dark
          ? "bg-[#1f2a47] border-[#18c98f]/40 text-white hover:bg-[#18c98f] hover:text-[#182138]"
          : "bg-white border-[#18c98f]/50 text-[#182138] hover:bg-[#18c98f] hover:text-white"
      }`}
      title={lang === "ar" ? "تغيير العملة" : "Change currency"}
      style={{ boxShadow: "0 0 14px -6px rgba(24,201,143,0.4)" }}
    >
      <Coins className="h-3.5 w-3.5" />
      <span className="text-base leading-none" aria-hidden="true">
        {C.flag}
      </span>
      <span className="tracking-wide">{currency}</span>
      <svg width="10" height="10" viewBox="0 0 20 20" fill="currentColor" className="opacity-80">
        <path d="M5 7l5 6 5-6H5z" />
      </svg>
      <select
        data-testid={`${testIdPrefix}-select`}
        value={currency}
        onChange={(e) => setCurrency && setCurrency(e.target.value)}
        className="absolute inset-0 opacity-0 w-full h-full cursor-pointer"
        style={{ WebkitAppearance: "none", appearance: "none" }}
        aria-label={lang === "ar" ? "تغيير العملة" : "Change currency"}
      >
        {Object.values(CURRENCIES).map((c) => (
          <option key={c.code} value={c.code}>
            {c.flag} {c.code} — {lang === "ar" ? c.name_ar : c.name_en}
          </option>
        ))}
      </select>
    </label>
  );
};

export default CurrencySwitcher;
